
// imports libary
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ToastrModule } from 'ngx-toastr';

// import component as pages
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './pages/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { DashboardMainViewComponent } from './pages/dashboard-main-view/dashboard-main-view.component';
import { WithdrawReportNormalComponent } from './components/dashboard/withdraw-report-normal/withdraw-report-normal.component';
import { BoothTableComponent } from './components/dashboard/booth-table/booth-table.component';
import { httpInterceptorProviders } from './common/utility/interceptor';
import { CustomerCountViewComponent } from './components/dashboard/customer-count-view/customer-count-view.component';
import { MonthlyWaterDispenseComponent } from './components/dashboard/bar-chart/monthly-water-dispense/monthly-water-dispense.component';
import { MonthlyRechargeComponent } from './components/dashboard/bar-chart/monthly-recharge/monthly-recharge.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MapPumpMarkerComponent } from './components/dashboard/map-pump-marker/map-pump-marker.component';
import { ChartsModule } from 'ng2-charts'
@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        LayoutComponent,
        DashboardMainViewComponent,
        WithdrawReportNormalComponent,
        BoothTableComponent,
        CustomerCountViewComponent,
        MonthlyWaterDispenseComponent,
        MonthlyRechargeComponent,
        SidebarComponent,
        MapPumpMarkerComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        NgxChartsModule,
        ChartsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyAmOIe2jK-ABATsHQHhan1KW0xZdV5zgRc'
        }),
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        })
    ],
    providers: [
        httpInterceptorProviders,
        DatePipe
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule { }
